export default "__VITE_PUBLIC_ASSET__cc92afdf__"